import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  --scrollOffset: var(--headerHeight, 0px);
  --sectionSpacing: ${fluid(40, 66)};

  &[data-spacing='margin'],
  &[data-spacing='padding'] {
    scroll-margin: calc(var(--scrollOffset) + var(--sectionSpacing)) 0 0;
  }

  &[data-spacing='margin'] {
    margin: var(--sectionSpacing) 0;
  }

  &[data-spacing='padding'] {
    padding: var(--sectionSpacing) 0;
  }

  &[data-spacing='none'] {
    scroll-margin: var(--scrollOffset) 0 0;
  }

  position: relative;
  z-index: 5;

  &[data-hide-overflow='true'] {
    overflow: hidden;
  }
`;
const Inner = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
